module.exports = __webpack_public_path__ + "static/img/news-demo1.535c55a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/news-demo1.png
// module id = q8wD
// module chunks = 150